import Image from "@/atoms-react/image/Image.react";
import { Base } from "@/atoms-react/text/Text.react";
import { FromURL } from "@/features/flow/types";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export type PartnerCardListType = {
  src: string;
  partner: string;
  balance: string;
  onChainBalance: string;
  tokenName: string;
  mode: string;
  host: string;
  name: string;
  updatePartner?: (
    partner: FromURL,
    url: string,
    partnerType?: string,
    lang?: string
  ) => Promise<void>;
};
export const TransfertCardList = (props: PartnerCardListType) => {
  const { t } = useTranslation(["pass"]);
  const { getLanguage } = usei18n();
  return (
    <div
      className="cursor-pointer"
      onClick={() => props?.updatePartner?.(FromURL.Partner, props.host, props.name, getLanguage())}
    >
      <div className="mt-2 flex flex-col border-2 border-slate-50 p-6 lg:hidden dark:border-slate-700">
        <div className="flex w-full flex-row">
          <div
            className={twMerge(
              "flex h-8 w-8 flex-col justify-center rounded-full bg-black lg:h-10 lg:w-10 dark:bg-transparent",
              props.src.includes("kypayIcon") && "bg-transparent"
            )}
          >
            <div className="flex flex-row justify-center">
              <Image alt={props?.partner} src={props?.src} className="w-5" />
            </div>
          </div>
          <Base className="ml-4 flex flex-col justify-center font-semibold text-xl">
            {props?.partner.charAt(0).toUpperCase() + props?.partner.slice(1)}
          </Base>
        </div>
        <Base className="mt-5 text-md lg:text-lg">
          {" "}
          {t("olkypass.mainPage.olkypass.dashbord.title_kypay_sub")}
        </Base>

        <div className="mt-2 flex w-full flex-row justify-between">
          <Base className="font-semibold text-lg">EUR:</Base>
          <Base className="ml-4 font-bold text-xl">{props?.balance}</Base>
        </div>
        <Base className="mt-5 text-md lg:text-lg">
          {t("olkypass.mainPage.olkypass.dashbord.title_kypay_onChain")}
        </Base>

        <Base className="mt-5 text-md lg:text-lg">Token</Base>

        <div className="mt-2 flex w-full flex-row justify-between">
          <Base className="font-semibold text-lg">{props?.tokenName}:</Base>
          <Base className="ml-4 font-bold text-warning text-xl">{props?.onChainBalance}</Base>
        </div>
      </div>
      <div className="mt-3 hidden justify-between rounded-sm border-2 border-slate-50 px-2 py-6 lg:flex lg:flex-row lg:px-4 dark:border-slate-700">
        <div className="flex w-1/4 flex-row">
          <div
            className={twMerge(
              "flex h-8 w-8 flex-col justify-center rounded-full bg-black lg:h-10 lg:w-10 dark:bg-transparent",
              props.src.includes("kypayIcon") && "bg-transparent"
            )}
          >
            <div className="flex flex-row justify-center">
              <Image alt={props?.partner} src={props?.src} className="w-5" />
            </div>
          </div>
          <Base className="ml-4 flex flex-col justify-center font-semibold text-xl">
            {props?.partner.charAt(0).toUpperCase() + props?.partner.slice(1)}
          </Base>
        </div>

        <div className="flex w-1/2 flex-row">
          <Base className="font-semibold text-lg">EUR:</Base>
          <Base className="ml-4 font-bold text-xl">{props?.balance}</Base>
        </div>

        <div className="flex w-1/4 flex-row px-2">
          {props.mode === "TOKEN" && (
            <Base className="font-semibold text-lg"> {props?.tokenName}:</Base>
          )}
          {props.mode === "TOKEN" && (
            <Base className="ml-4 font-bold text-warning text-xl">{props?.onChainBalance}</Base>
          )}
        </div>
      </div>
    </div>
  );
};
